import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { AppHeader } from "../components"

export const PublicLayout = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="start"
      minHeight="100vh"
    >
      <AppHeader />
      <Outlet />
    </Box>
  )
}
